export default {
  messages: {
    maxFileSize: 'El tamaño del fichero debe ser igual o inferior a {1} Mb.',
    totalFileSize: 'El tamaño total de los ficheros debe ser igual o inferior a 8 Mb.',
    fileType: 'Formato de fichero no válido. El fichero debe ser {1}.',
    maxAmount: 'El importe de {0} supera el máximo permitido (99.999.999,00).',
    table: 'La tabla {0} debe contener al menos 1 elemento.',
    detailsTable: 'Para continuar, debe añadir al menos una línea de detalle',
    taxesTable: 'La tabla de Impuestos debe contener al menos 1 elemento',
    deliveryNotesTable: 'La tabla de Albarán debe contener al menos 1 elemento',
    taxesTypes: 'Los impuestos introducidos no pueden ser del mismo tipo',
    cifNotProvider: 'Los CIF emisor y receptor no pueden ser iguales',
    dateFromSubscription: 'No esta permitido filtrar en una cuenta gratuita por fecha anterior a tres meses del dia de hoy',
    dateMaxRange: 'La búsqueda solo puede abarcar un periodo máximo de 3 meses',
    clientEmailRequired: 'El campo de Email del cliente es obligatorio.',
    clientEmailInvalid: 'El Email del cliente no es válido.',
    notSupportedNumber: 'El Número introducido no puede coincidir con el ID de la factura',
    taxesIVA: 'Debe incluir al menos un impuesto de tipo IVA.',
    validFileName: 'El nombre del fichero contiene caracteres no permitidos. Solo se permiten letras, números, espacios, puntos, guiones, guiones bajos y paréntesis.'
  }
}
